<div id="w3l-appointment" style="width: 1000px;">
  <section class="appointment-section section-gap" >
    <div class="wrapper">
      <div class="d-grid doctor-appointment" >
        <div class="appointment-form" >
          <form action="#" method="post" >

              <div class="styled-input" >
                <div class="appointment-form-field">
                  <label style="width: 10%;">P.O. Serial</label>
                  <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"(click)="openDialogOrder()"></span>
                  <input type="text" name="PreparationOrderId" placeholder="Preparation Order Id" style="width: 20%;"required [(ngModel)]="documentCode" (change)="retrivePreHD()">
                  <label style="width: 2%;"></label>
                  <label style="width: 15%;">P.O. Date</label>
                  <span class="fa fa-calendar" aria-hidden="true"></span>
                  <input type="date" name="PreparationOrderDate" required style="width: 20%;" [(ngModel)]="docDate">
              </div>
              </div>
              <!-- <div class="styled-input">
                <div class="appointment-form-field">
                  <label style="width: 10%;">P.O. Date</label>
                  <span class="fa fa-calendar" aria-hidden="true"></span>
                  <input type="date" name="PreparationOrderDate" required style="width: 20%;" [(ngModel)]="docDate">
                  <label style="width: 2%;"></label>
                  <label style="width: 15%;">Patient Status</label>
                  <span class="fa fa-clone" aria-hidden="true"></span>
                  <select id="PatientStatus" name="PatientStatus" style="width: 33%;background-color:  rgb(187, 203, 238);" [(ngModel)]="pstatus" [value]="pstatus"
                    required>
                    <option value="Adjuvant">Adjuvant </option>
                    <option value="Neoadjuvant">Neoadjuvant</option>
                    <option value="Metastatic">Metastatic</option>

                  </select>


                </div>
              </div> -->
              <!------ Doctores ------->
              <div class="styled-input">


                <div class="appointment-form-field" >
                  <label style="width: 10%;">Doctor</label>
                  <span class="fa fa-headphones" aria-hidden="true"></span>
                  <select id="doctor"   name="doctor" required="" [(ngModel)]="docCode" [value]="docName" style="width: 20%;color:black;">
                    <option value="{{doc.docCode}}" *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}
                    </option>
                  </select>
                  <label style="width: 2%;"></label>
                  <label style="width: 15%;">Pharmacist</label>
                  <span class="	fa fa-user-md" aria-hidden="true"></span>
                  <select id="doctor" name="doctorPharm" required="" [(ngModel)]="docCode1" [value]="docName1" style="width: 20%;">
                    <option value="{{doc.docCode}}" *ngFor="let doc of doctorsLis1; let i = index">{{doc.docName}}
                    </option>
                  </select>
                </div>

              </div>
              <!------ Patient Data ------->
              <div class="styled-input">


                <div class="appointment-form-field">
                  <label style="width: 10%;">Patient ID</label>
                  <span type="submit" class="fa fa-search" (click)="openDialog()" style="cursor: grab;"></span>
                  <input type="text" name="patientId" placeholder="Pat. Code" style="width: 20%;" required [(ngModel)]="patientCode" (change)="retrievePatient()">
                  <input type="text" name="patientName" disabled style="width: 41%;background-color:  rgb(187, 203, 238);" [(ngModel)]="patientFName">

                </div>
              </div>

              <div class="styled-input" style="background-color: rgb(187, 187, 255);width: 75%;border-style: groove;border-color:rgb(199, 219, 250) ;border-radius: 3%;">

              <div class="styled-input">

                  <div class="appointment-form-field" style="width: 99%;background-color: rgb(187, 187, 255);">
                      <label style="width: 15%;font-size: 80%;background-color: rgb(187, 187, 255);">Pulse(b.p.m) النبض</label>
                      <input type="text" name="puls" id="puls" required placeholder="00" style="width: 8%;font-size:1.5ch;" [(ngModel)]="prHdPulse">
                      <label style="width: 15%;"></label>

                      <label style="width: 15%;font-size: 80%;background-color: rgb(187, 187, 255);">B.P ضغط الدم</label>
                      <input type="text" name="BP" placeholder="000/000" style="width: 10%; font-size:1.5ch;"[(ngModel)]="prHdB_P">
                      <label style="width: 15%;"></label>

                      <label style="width: 15%;font-size: 80%;background-color: rgb(187, 187, 255);">Temp(cº) الحرارة</label>
                      <input type="text" name="temp" value="37" placeholder="00.00" required="" style="width: 8%;font-size:1.5ch;" [(ngModel)]="prHdTemp">

                  </div>

                  <div class="appointment-form-field" style="width: 99%;background-color: rgb(187, 187, 255);">
                    <label style="width: 15%;font-size: 80%;background-color: rgb(187, 187, 255);">CBG(mg\dl)</label>
                    <input type="text" name="cbg" placeholder="00.00" required="" style="width: 8%;font-size:1.5ch;" [(ngModel)]="prHdCBG">
                    <label style="width: 15%;"></label>

                    <label style="width: 14.5%;font-size: 80%;background-color: rgb(187, 187, 255);">Weight(Kg) الوزن</label>
                    <input type="text" name="weight" placeholder="00.00" required="" style="width: 10%;font-size:1.5ch;" [(ngModel)]="prHdWeight">
                    <label style="width: 14.5%;"></label>

                    <label style="width: 15%;font-size: 80%;background-color: rgb(187, 187, 255);">Height(cm) الطول</label>
                    <input type="text" name="height" placeholder="00.00" required="" style="width: 8%;font-size:1.5ch;"   [(ngModel)]="prHdHeight">

                  </div>

                  <div class="appointment-form-field" style="width: 99%;background-color: rgb(187, 187, 255);">
                    <label style="width: 16%;font-size: 80%;background-color: rgb(187, 187, 255);">Notesملاحظات التمريض</label>
                    <input type="text" name="nunotes" id="nunotes" required  style="width: 91%;font-size:1.5ch;" [(ngModel)]="nursingnotes">

                  </div>
              </div>
              </div>
              <div class="styled-input">
<!--
                <div class="styled-input">
                  <label>▀ N.B :         Bonet  : </label>
                  <input type="radio" name="DStatus" value="Yes" [(ngModel)]="prHdBonet"> Yes    
                  <input type="radio" name="DStatus" value="No" [(ngModel)]="prHdBonet" checked> No
                </div> -->

                <div class="appointment-form-field" style="width: 75%;">
                  <label style="width: 15%;">Adj.B.W(kg)</label>
                  <span class="fa fa-hotel" aria-hidden="true"></span>
                  <input type="text" name="prHdAdj" style="width: 20%;" [(ngModel)]="prHdAdj" placeholder="00.00" required=""    style="width: 25%;font-size:1.1ch;">
                  <label  style="width: 2%;"></label>

                  <label style="width: 10%;">B.SA(m2)</label>
                  <span class="fa fa-calendar-check-o" aria-hidden="true"></span>
                  <input type="text" name="prHdBsa"  [(ngModel)]="prHdBsa" placeholder="00.00" required=""  style="width: 20%;font-size:1.1ch;">
                  <label  style="width: 2%;"></label>
                  <label style="width: 10%;">Cycle</label>
                  <span class="fa fa-calendar-check-o" aria-hidden="true"></span>
                  <input type="text" name="days1" [(ngModel)]="prHdCycle" placeholder="00.00" required=""  style="width: 20%;font-size:1.1ch;">
                  <label  style="width: 5%;"></label>
                  <label style="width: 10%;">Day</label>
                  <span class="fa fa-hotel" aria-hidden="true"></span>
                  <input type="text" name="Day" [(ngModel)]="prHdDays" placeholder="00.00" required="" style="width: 22%;font-size:1.1ch;">
                  <label style="width: 2%;"></label>

        </div>
<BR><BR>
                <div class="appointment-form-field" style="width: 75%;">
                  <label  style="width: 15%;">Dose Modification</label>
                  <span class="fa fa-percent" aria-hidden="true"></span>
                  <input type="text" [(ngModel)]="prHdModifPerc" name="modificationPr" maxlength="2ch" style="width: 15%;font-size:1.1ch;" placeholder="00">
                  <label style="width: 11.5%;">Whay</label>

                  <span class="fa fa-pencil-square-o" aria-hidden="true" style="height: 200%;"></span>
                  <textarea rows="5" cols="60" name="whay" [(ngModel)]="prHdWhay" class="appointment-form-field"  style="height: 200%;" maxlength="150ch" placeholder="Details... "> </textarea><br>
                </div>
                <BR>
              </div>

              <div class="styled-input">

                <!-- <div class="appointment-form-field" style="width: 92%;">
                  <label  style="width: 11%;">Protocol</label>
                  <span type="submit" class="fa fa-search" (click)="mesgReload()" style="cursor: grab;"></span>
                  <input type="text" name="protocolId" placeholder="Protocol ID" style="width: 20%;"  [(ngModel)]="prHdCode" required disabled>
                  <input type="text" name="ProtocolName" disabled style="width: 68%;" [(ngModel)]="prHdName">
                </div> -->

              </div>
              <!---------- ********** Pre-Medication Treatment table *****--------->
              <div>
                <label class="appointment-form-field"
                  style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Pre-Medication  
                </label>
                <table>
                <thead>
                    <tr>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 30%;height: 10%;">Drug</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 15%;">Duration</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 15%;">Solution</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 10%;">Start Time</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 10%;">End Time</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 22%;height: 10%;">Notes</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 8%;height: 10%;">ٍSave</th>
                    </tr>
                </thead>
                  <tbody>

                    <tr *ngFor="let pro of prepList; let i = index" style="height: 50%;">
                      <td data-column="Patient ID" style="height: 50%;">{{pro.drgsconcatenate}}<BR><BR>
                        <label dir="rtl" style="font-weight: bold;text-align: right;">{{pro.ardrgsconcatenate}}</label></td>
                      <td data-column="Patient Name" style="height: 50%;">{{pro.prepduration}}</td>

                      <td data-column="Patient QTY" style="height: 50%;">{{pro.solution}}</td>
                      <td data-column="Patient Unit11" style="height: 50%;"><button type="button" class="theme-button btn" name="start"  (click)="SetTimeStartPre(pro)">{{pro.strattime}}</button> </td>
                      <td data-column="Patient Dose" style="height: 50%;"> <button type="button" class="theme-button btn" name="end"  (click)="SetTimeEndPre(pro)">{{pro.enditime}}</button></td>
                      <td data-column="Dos" style="height: 50%;">
                        <label dir="rtl" class="appointment-form-field" style="height: 60px;overflow: hidden;text-align: right;font-weight: bold;">{{pro.nursecomments1}}</label>
                        <textarea dir="rtl" name="commentat" class="appointment-form-field" maxlength="150ch" placeholder="من فضلك إدخل الملاحظات ... " [(ngModel)]="pro.nursecomments" ></textarea>
                      </td>
                      <td data-column="Patient Dose" style="height: 50%;"> <button type="button" class="fa fa-floppy-o" name="sav"  style="width:100%;height: 100px;font-size: 150%;border-radius: 10%;" (click)="SaveNotes(pro)"></button></td>
                    </tr>
                  </tbody>
                </table>


              </div>

              <BR>
              <BR>
              <!---------- ********** Chemotherapy Treatment table *****--------->

              <div>
                <label class="appointment-form-field"
                  style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Prepared Treatment  
                </label>
                <table>
                <thead>
                    <tr>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 30%;height: 10%;">Drug</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 15%;">Duration</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 15%;">Solution</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 10%;">Start Time</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 10%;height: 10%;">End Time</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 22%;height: 10%;">Notes</th>
                      <th style="background-color:  rgb(70, 70, 247);color: white;width: 8%;height: 10%;">Save</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cho of prepListChemo; let i = index" style="height: 50%;">
                      <td data-column="Patient ID" style="height: 50%;">{{cho.drgsconcatenate}}<BR><BR>
                        <label dir="rtl" style="font-weight: bold;text-align: right;">{{cho.ardrgsconcatenate}}</label></td>
                      <td data-column="Patient Name" style="height: 50%;">{{cho.prepduration}}</td>

                      <td data-column="Patient QTY" style="height: 50%;">{{cho.solution}}</td>
                      <td data-column="Patient Unit11" style="height: 50%;"><button type="button" class="theme-button btn"name="start" (click)="SetTimeStartChemo(cho)">{{cho.strattime}}</button> </td>
                      <td data-column="Patient Dose" style="height: 50%;"> <button type="button" class="theme-button btn" name="end"  (click)="SetTimeEndChemo(cho)">{{cho.enditime}}</button></td>
                      <td data-column="comments" style="height: 50%;">
                        <label dir="rtl" class="appointment-form-field" style="height: 60px;overflow: hidden;text-align: right;font-weight: bold;">{{cho.nursecomments1}}</label>
                        <textarea  name="commentat" class="appointment-form-field" maxlength="150ch" placeholder="من فضلك إدخل الملاحظات ... " [(ngModel)]="cho.nursecomments" ></textarea></td>
                      <td data-column="Patient Dose" style="height: 50%;"><button type="button" class="fa fa-floppy-o"   name="sav"  style="width:100%;height: 100px;font-size: 150%;border-radius: 10%;" (click)="SaveNotesChemo(cho)"></button></td>
                    </tr>

                  </tbody>
                </table>

              </div>
              <!---------- *********************************************--------->
              <BR>
              <BR>
              <!---------- ********** Supportive Treatment table *****--------->
              <!-- <div>
                <label class="appointment-form-field"
                  style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: larger;">  Discharge Medications   </label>
                <table>
                  <thead>
                    <tr>
                      <th style="background-color: rgb(70, 70, 247);color: white;width: 30%;height: 10%;">Drug</th>
                      <th style="background-color: rgb(70, 70, 247);color: white;width: 10%;height: 15%;">Duration</th>
                      <th style="background-color: rgb(70, 70, 247);color: white;width: 10%;height: 15%;">Solution</th>
                      <th style="background-color: rgb(70, 70, 247);color: white;width: 10%;height: 10%;">Start Time</th>
                      <th style="background-color: rgb(70, 70, 247);color: white;width: 10%;height: 10%;">End Time</th>
                      <th style="background-color: rgb(70, 70, 247);color: white;width: 22%;height: 10%;">Notes</th>
                      <th style="background-color: rgb(70, 70, 247);color: white;width: 8%;height: 10%;">Save</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sup of prepListSupp; let i = index" style="height: 50%;">
                      <td data-column="Patient ID" style="height: 50%;">{{sup.drgsconcatenate}}<BR><BR>
                        <label dir="rtl" style="font-weight: bold;">{{sup.ardrgsconcatenate}}</label></td>
                      <td data-column="Patient Name" style="height: 50%;">{{sup.prepduration}}</td>
                      <td data-column="Patient QTY" style="height: 50%;">{{sup.solution}}</td>
                      <td data-column="Patient Unit11" style="height: 50%;"><button type="button" class="theme-button btn" name="start"  (click)="ReportPreparation()">{{sup.strattime}}</button> </td>
                      <td data-column="Patient Dose" style="height: 50%;"> <button type="button" class="theme-button btn" name="end"  (click)="ReportPreparation()">{{sup.enditime}}</button></td>
                      <td data-column="Dos" style="height: 50%;">
                        <textarea rows="5" cols="60" name="description" class="appointment-form-field" style="height: 150%;" maxlength="150ch" placeholder="Enter details here... " > </textarea>
                        <td data-column="Patient Dose" style="height: 50%;"> <button type="button" class="fa fa-floppy-o" name="sav"  style="width:100%;height: 100px;font-size: 150%;border-radius: 10%;" (click)="SaveNotes(sup)"></button></td>

                    </tr>

                  </tbody>
                </table>

              </div> -->
              <!---------- ***********************************--------->



              <div class="styled-input">
                <label>Notes in Details</label>
                <BR>
                <BR>
                <div class="appointment-form-field">
                  <span class="fa fa-university" aria-hidden="true" style="height: 200%;"></span>
                  <textarea rows="5" cols="60" name="description" class="appointment-form-field" style="height: 200%;"
                    maxlength="150ch" placeholder="Enter details here... " [(ngModel)]="prNotes"> </textarea><br>
                </div>
              </div>
              <div style="text-align: center; ">
                <button type="button" class="theme-button btn" name="submit"  (click)="OpenDialogCurrentMedication()"  style="background-color: rgb(0, 0, 118);color: white;width: 690px;" >Current Non-cancer Medication - Drug-Drug Interactions</button>
               </div>
            
              <div style="text-align: center; ">
              <button type="button" class="theme-button btn" name="print"  (click)="ReportPreparation()">Print</button>
              <button type="button" class="theme-button btn" name="calc"   (click)="OpenCalc()">Calculator</button>
              <button type="button" class="theme-button btn" name="Back">Home</button>
             </div>

          </form>
        </div>


        <div class="registerimg" >

          <div class="styled-input">
            <BR>
            <!--************* Table for Previous transactions  ***********-->
            <label style="width: 300px;background-color: rgb(102, 102, 111);color: white; font-weight: bold;font-size: larger;text-align: center;height: 30px;padding-top: 1%;">Pervious Prepartion Orders</label>
            <table style="width: 300px;">
              <thead>
                <tr>
                  <th style="background-color:  rgb(102, 102, 111);color: white;width: 33%;text-align: center;">Visit Date</th>
                  <th style="background-color:  rgb(102, 102, 111);color: white;width: 33%;text-align: center;">P.O. No</th>
                  <th style="background-color:  rgb(102, 102, 111);color: white;width: 33%;text-align: center;">Select</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let sup of prevPOList; let i = index" style="height: 50%;">
                  <td data-column="Patient Name" style="height: 50%;">{{sup.docDate}}</td>
                  <td data-column="Patient Name" style="height: 40%;">{{sup.docNumber}}</td>
                  <button name="printpreviousrug3" placeholder="0" style="width: 100%;height: 37px;" required (click)="PreviousReportPreparation(sup)">Select</button>
                </tr>
              </tbody>
            </table>
            <BR>
            <BR>
          </div>
          <BR>
            <section style="top: 350px;overflow-y: scroll;height: 680px;">

                <div class="styled-input">
                  <div class="styled-input">
                    <label style="width: 690px;background-color: rgb(102, 102, 111);color: white; font-weight: bold;font-size: larger;text-align: center;height: 30px;padding-top: 1%;">Doctor Requests</label>
                    <table style="left: 50px;width: 690px;table-layout: fixed;">
                      <tr>
                        <th style="width: 35%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Regimen</th>
                        <th style="width: 7%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">No. of Cycle</th>
                        <th style="width: 5%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Day</th>
                        <!-- <th style="width: 15%;background-color:  rgb(102, 102, 111);color: white;">Start Date</th> -->
                        <th style="width: 12%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Dose</th>
                        <th style="width: 7%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Modif. Dose %</th>
                        <th style="width: 20%;background-color:  rgb(102, 102, 111);color: white;text-align: center;">Notes</th>
                      </tr>
                      <tr *ngFor="let item of cancertreatmentList; let i = index" style="font-size: {{wk_fontsize}};text-align: left;height: 50%;">
                        <td><label style="font-weight: bold;color: rgb(29, 0, 95);"  [hidden]="hiddenhead" ><u>{{item.trdate}} {{item.username}}</u></label><br>{{item.trkind}} </td>
                        <td>{{item.trcycleno}} </td>
                        <td>{{item.trdayscycle}} </td>
                        <!-- <td>{{item.trstartdate}} </td> -->
                        <td>{{item.trdose}} {{item.trunit}} </td>

                        <td>{{item.trdosemod}}% </td>
                        <td>

                          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                              <label>{{item.trnotes}}</label>
                          </div>
                        </td>

                      </tr>
                    </table>
                  </div>
                  <div style="text-align: center; ">
                    <a href="DoctorObservationTab" style="cursor: grab;">

                    <button type="button" class="theme-button btn" name="submit"  style="width: 690px;" (click)="DoctorObservation()" >Physician Assessment (Tab)</button>
                  </a>
                  </div>
                </div>

            </section>

        </div>
      </div>
    </div>
  </section>
</div>

